import {prop} from 'ramda'
import { empty } from '@bluecrew/bluecrew-lib'
import api from './api'
import Debug from 'debug'
const debug = Debug('app:shared:region')

const region = ($http, $q) => {
  'ngInject'

  let regions = []

  const getRegions = () => {
    if (!empty(regions)) {
      debug('puling crew from cache')
      let def = $q.defer()
      def.resolve(regions)
      return def.promise
    }
    return fetchRegions()
  }

  const fetchRegions = () => {
    return $http({
      method: 'GET',
      url: `${api.getBase()}/regions`
    })
    .then(prop('data'))
    .then(getRegionsSuccess)
  }

  const getRegionsSuccess = (data) => {
    regions = data
    return data
  }

  const removeRegion = (data) => {
  }

  const addUsersToRegion = (users) => {
  }

  const update = (id, data) => {
    return $http({
      method: 'PATCH',
      url: `${api.getBase()}/region/${id}`,
      data
    })
    .then(() => console.log('wow'))
  }

  const bulkEmailDrip = (data) => {
    return $http({
      method: 'POST',
      url: `${api.getBase()}/user/drip/interviewReminder`,
      data
    })
    .then(prop('data'))
  }

  /**
   * Make http request to create the crew. Add created crew to cached crews array.
   */
  const create = (data) => {
    return $http({
      method: 'POST',
      url: `${api.getBase()}/region`,
      data
    })
    .then(prop('data'))
  }

  return {
    bulkEmailDrip,
    getRegions,
    removeRegion,
    addUsersToRegion,
    update,
    create
  }
}

export default region
